<template>
  <div id="main">
    <v-index>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>教学</el-breadcrumb-item>
        <el-breadcrumb-item><a style="color: #000000;">教师教评</a></el-breadcrumb-item>
      </el-breadcrumb>

      <v-weburl-iframe url="teacher/evaluation" />
    </v-index>
  </div>
</template>

<script>
import VIndex from "@/components/common";
import VWeburlIframe from "@/components/weburl-iframe";
export default {
  name: 'evaluation',
  components: {VWeburlIframe, VIndex}
}
</script>

<style scoped>

</style>
